module.exports = __webpack_public_path__ + "img/analytics.f311b4a4.png";